var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgBrandContentfulStyleBlack = function SvgBrandContentfulStyleBlack(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M8.623 16.674c-1.271-1.197-2.019-2.842-2.019-4.711s.748-3.514 1.944-4.71a2.62 2.62 0 0 0 0-3.739 2.62 2.62 0 0 0-3.738 0c-2.094 2.168-3.44 5.16-3.44 8.449 0 3.29 1.346 6.28 3.514 8.449a2.62 2.62 0 0 0 3.739 0 2.76 2.76 0 0 0 0-3.738"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M8.623 7.253c1.196-1.271 2.841-2.02 4.71-2.02 1.87 0 3.514.749 4.71 1.945a2.62 2.62 0 0 0 3.74 0 2.62 2.62 0 0 0 0-3.739C19.612 1.346 16.622 0 13.332 0s-6.28 1.346-8.449 3.514a2.62 2.62 0 0 0 0 3.739 2.76 2.76 0 0 0 3.739 0M18.044 16.674c-1.197 1.27-2.841 2.018-4.71 2.018a6.6 6.6 0 0 1-4.711-1.944 2.62 2.62 0 0 0-3.739 0 2.62 2.62 0 0 0 0 3.739c2.169 2.093 5.16 3.44 8.45 3.44s6.28-1.347 8.448-3.515a2.62 2.62 0 0 0 0-3.738 2.76 2.76 0 0 0-3.738 0"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgBrandContentfulStyleBlack);
export { ForwardRef as ReactComponent };